import MessageBox from './index.vue';

// 定义插件对象
const __MessageBox__ = {};
// vue的install方法，用于定义vue插件
__MessageBox__.install = function(Vue, options) {
  const __MessageBox__Instance = Vue.extend(MessageBox);
  let current;
  const initInstance = () => {
    // 实例化vue实例
    current = new __MessageBox__Instance();
    let __MessageBox__El = current.$mount().$el;
    document.body.appendChild(__MessageBox__El);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$messageBox = {
    /**
     * 成功消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.title 标题
     * @param {String} options.message 消息内容
     * @param {Boolean} options.dangerouslyUseHTMLString 是否使用html
     * @param {Boolean} options.showCancelButton 是否展示取消按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.cancelButtonText 取消按钮文本内容
     * @param {Boolean} options.showConfirmButton 是否展示确认按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.confirmButtonText 确认按钮文本内容
     * @param {Boolean} options.showClose 是否展示关闭按钮图标
     * @param {Function} options.callback 关闭后的回调（返回action参数：action 的值为'confirm', 'cancel', 'close'，confirm：用户确认，cancel：用户取消，close：直接关闭/系统关闭）
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框，调用 Close 时会触发 callback
     */
    success(options) {
      if (!current) {
        initInstance();
      }
      return current.fnSuccess(options);
    },
    /**
     * 提示消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.title 标题
     * @param {String} options.message 消息内容
     * @param {Boolean} options.showCancelButton 是否展示取消按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.cancelButtonText 取消按钮文本内容
     * @param {Boolean} options.showConfirmButton 是否展示确认按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.confirmButtonText 确认按钮文本内容
     * @param {Boolean} options.showClose 是否展示关闭按钮图标
     * @param {Function} options.callback 关闭后的回调（返回action参数：action 的值为'confirm', 'cancel', 'close'，confirm：用户确认，cancel：用户取消，close：直接关闭/系统关闭）
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框，调用 Close 时会触发 callback
     */
    info(options) {
      if (!current) {
        initInstance();
      }
      return current.fnInfo(options);
    },
    /**
     * 警示消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.title 标题
     * @param {String} options.message 消息内容
     * @param {Boolean} options.showCancelButton 是否展示取消按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.cancelButtonText 取消按钮文本内容
     * @param {Boolean} options.showConfirmButton 是否展示确认按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.confirmButtonText 确认按钮文本内容
     * @param {Boolean} options.showClose 是否展示关闭按钮图标
     * @param {Function} options.callback 关闭后的回调（返回action参数：action 的值为'confirm', 'cancel', 'close'，confirm：用户确认，cancel：用户取消，close：直接关闭/系统关闭）
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框，调用 Close 时会触发 callback
     */
    warning(options) {
      if (!current) {
        initInstance();
      }
      return current.fnWarning(options);
    },
    /**
     * 错误消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.title 标题
     * @param {String} options.message 消息内容
     * @param {Boolean} options.showCancelButton 是否展示取消按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.cancelButtonText 取消按钮文本内容
     * @param {Boolean} options.showConfirmButton 是否展示确认按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.confirmButtonText 确认按钮文本内容
     * @param {Boolean} options.showClose 是否展示关闭按钮图标
     * @param {Function} options.callback 关闭后的回调（返回action参数：action 的值为'confirm', 'cancel', 'close'，confirm：用户确认，cancel：用户取消，close：直接关闭/系统关闭）
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框，调用 Close 时会触发 callback
     */
    error(options) {
      if (!current) {
        initInstance();
      }
      return current.fnError(options);
    },
    /**
     * 询问消息
     * @param {Boolean} options.showIcon 是否展示图标
     * @param {Boolean} options.showIconColored 是否展示图标颜色
     * @param {String} options.title 标题
     * @param {String} options.message 消息内容
     * @param {Boolean} options.showCancelButton 是否展示取消按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.cancelButtonText 取消按钮文本内容
     * @param {Boolean} options.showConfirmButton 是否展示确认按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
     * @param {String} options.confirmButtonText 确认按钮文本内容
     * @param {Boolean} options.showClose 是否展示关闭按钮图标
     * @param {Function} options.callback 关闭后的回调（返回action参数：action 的值为'confirm', 'cancel', 'close'，confirm：用户确认，cancel：用户取消，close：直接关闭/系统关闭）
     * @returns 返回当前组件对象实例，可调用 Close 方法关闭消息框，调用 Close 时会触发 callback
     */
    question(options) {
      if (!current) {
        initInstance();
      }
      return current.fnQuestion(options);
    }
  };
};
export default __MessageBox__;
